import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import {  RolesAndStudyComponent } from './components/roles-and-study/roles-and-study.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AuthGuardService } from './services/auth-guard.service'
import { AuthService } from './services/auth.service'
import { ToastrModule } from 'ngx-toastr'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { CaptchaModule } from "./components/shared/captcha/captcha.module";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CookieService } from  'ngx-cookie-service'
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [AppComponent, LoginComponent,
    RolesAndStudyComponent, 
    ForgotPasswordComponent,
    ChangePasswordComponent ], 
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CaptchaModule,
    NgSelectModule,
    BrowserAnimationsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ToastrModule.forRoot({
      progressBar: true,
      progressAnimation: 'increasing',
      closeButton: true,
      newestOnTop: true
  }),

  ],
  providers: [
    {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthService,
        multi: true
    },
    CookieService,
    AuthGuardService,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
